









import { Component, Vue, Prop } from 'vue-property-decorator';
import { NoSSR } from '@jtnews/shared/ui';
import { useStore } from 'vuex-simple';

type YandexData = {
  desktop: string;
  mobile: string;
};

@Component({
  name: 'YandexRecommendedWidget',
  components: {
    NoSSR
  }
})
export default class YandexRecommendedWidget extends Vue {
  @Prop({
    type: Object as () => YandexData,
    default: null
  })
  content: YandexData;

  store = useStore(this.$store);

  get isMobile() {
    return this.store.deviceInfo.isMobile;
  }

  get yandexId() {
    return this.isMobile ? this.content.mobile : this.content.desktop;
  }

  get containerId() {
    return `yandex_recommended_widget_${this.yandexId}`;
  }

  mounted() {
    const win = window as any;
    win.yaContextCb = win.yaContextCb || [];

    win.yaContextCb.push(() => {
      win.Ya.Context.AdvManager.renderWidget({
        renderTo: `${this.containerId}`,
        blockId: `${this.yandexId}`
      });
    });
  }
}
